export enum CountryActions {
  GET_ALL_COUNTRY_NAMES_REQUEST = "GET_ALL_COUNTRY_NAMES_REQUEST",
  GET_ALL_COUNTRY_NAMES_SUCCESS = "GET_ALL_COUNTRY_NAMES_SUCCESS",
  GET_HAS_PHONE_FEATURE_COUNTRIES_DATA_REQUEST = "GET_HAS_PHONE_FEATURE_COUNTRIES_DATA_REQUEST",
  GET_HAS_PHONE_FEATURE_COUNTRIES_DATA_SUCCESS = "GET_HAS_PHONE_FEATURE_COUNTRIES_DATA_SUCCESS",
  COUNTRY_ERROR = "COUNTRY_ERROR",
}
